/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addContactsToSegment } from '../fn/contact-segment-api/add-contacts-to-segment';
import { AddContactsToSegment$Params } from '../fn/contact-segment-api/add-contacts-to-segment';
import { ApiResponseContactSegment } from '../models/api-response-contact-segment';
import { ApiResponseContactSegmentMembersResult } from '../models/api-response-contact-segment-members-result';
import { ApiResponseListContactSegment } from '../models/api-response-list-contact-segment';
import { ApiResponsePagedResultContact } from '../models/api-response-paged-result-contact';
import { ApiResponsePagedResultContactSegment } from '../models/api-response-paged-result-contact-segment';
import { ApiResponseVoid } from '../models/api-response-void';
import { archiveContactSegment } from '../fn/contact-segment-api/archive-contact-segment';
import { ArchiveContactSegment$Params } from '../fn/contact-segment-api/archive-contact-segment';
import { createContactSegment } from '../fn/contact-segment-api/create-contact-segment';
import { CreateContactSegment$Params } from '../fn/contact-segment-api/create-contact-segment';
import { deleteContactSegment } from '../fn/contact-segment-api/delete-contact-segment';
import { DeleteContactSegment$Params } from '../fn/contact-segment-api/delete-contact-segment';
import { getContactSegment } from '../fn/contact-segment-api/get-contact-segment';
import { GetContactSegment$Params } from '../fn/contact-segment-api/get-contact-segment';
import { listContactSegment } from '../fn/contact-segment-api/list-contact-segment';
import { ListContactSegment$Params } from '../fn/contact-segment-api/list-contact-segment';
import { removeContactsFromSegment } from '../fn/contact-segment-api/remove-contacts-from-segment';
import { RemoveContactsFromSegment$Params } from '../fn/contact-segment-api/remove-contacts-from-segment';
import { searchContactSegment } from '../fn/contact-segment-api/search-contact-segment';
import { SearchContactSegment$Params } from '../fn/contact-segment-api/search-contact-segment';
import { searchSegmentContacts } from '../fn/contact-segment-api/search-segment-contacts';
import { SearchSegmentContacts$Params } from '../fn/contact-segment-api/search-segment-contacts';
import { updateContactSegment } from '../fn/contact-segment-api/update-contact-segment';
import { UpdateContactSegment$Params } from '../fn/contact-segment-api/update-contact-segment';

@Injectable({ providedIn: 'root' })
export class ContactSegmentApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getContactSegment()` */
  static readonly GetContactSegmentPath = '/v1/api/ui/contactSegment/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactSegment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSegment$Response(params: GetContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegment>> {
    return getContactSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactSegment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSegment(params: GetContactSegment$Params, context?: HttpContext): Observable<ApiResponseContactSegment> {
    return this.getContactSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactSegment>): ApiResponseContactSegment => r.body)
    );
  }

  /** Path part for operation `updateContactSegment()` */
  static readonly UpdateContactSegmentPath = '/v1/api/ui/contactSegment/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContactSegment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactSegment$Response(params: UpdateContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegment>> {
    return updateContactSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContactSegment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactSegment(params: UpdateContactSegment$Params, context?: HttpContext): Observable<ApiResponseContactSegment> {
    return this.updateContactSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactSegment>): ApiResponseContactSegment => r.body)
    );
  }

  /** Path part for operation `deleteContactSegment()` */
  static readonly DeleteContactSegmentPath = '/v1/api/ui/contactSegment/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteContactSegment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContactSegment$Response(params: DeleteContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return deleteContactSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteContactSegment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContactSegment(params: DeleteContactSegment$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.deleteContactSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `archiveContactSegment()` */
  static readonly ArchiveContactSegmentPath = '/v1/api/ui/contactSegment/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveContactSegment()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveContactSegment$Response(params: ArchiveContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegment>> {
    return archiveContactSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveContactSegment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveContactSegment(params: ArchiveContactSegment$Params, context?: HttpContext): Observable<ApiResponseContactSegment> {
    return this.archiveContactSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactSegment>): ApiResponseContactSegment => r.body)
    );
  }

  /** Path part for operation `createContactSegment()` */
  static readonly CreateContactSegmentPath = '/v1/api/ui/contactSegment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createContactSegment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContactSegment$Response(params: CreateContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegment>> {
    return createContactSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createContactSegment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContactSegment(params: CreateContactSegment$Params, context?: HttpContext): Observable<ApiResponseContactSegment> {
    return this.createContactSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactSegment>): ApiResponseContactSegment => r.body)
    );
  }

  /** Path part for operation `addContactsToSegment()` */
  static readonly AddContactsToSegmentPath = '/v1/api/ui/contactSegment/{ref}/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addContactsToSegment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContactsToSegment$Response(params: AddContactsToSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegmentMembersResult>> {
    return addContactsToSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addContactsToSegment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContactsToSegment(params: AddContactsToSegment$Params, context?: HttpContext): Observable<ApiResponseContactSegmentMembersResult> {
    return this.addContactsToSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactSegmentMembersResult>): ApiResponseContactSegmentMembersResult => r.body)
    );
  }

  /** Path part for operation `searchSegmentContacts()` */
  static readonly SearchSegmentContactsPath = '/v1/api/ui/contactSegment/{ref}/contacts/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSegmentContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSegmentContacts$Response(params: SearchSegmentContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultContact>> {
    return searchSegmentContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSegmentContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSegmentContacts(params: SearchSegmentContacts$Params, context?: HttpContext): Observable<ApiResponsePagedResultContact> {
    return this.searchSegmentContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultContact>): ApiResponsePagedResultContact => r.body)
    );
  }

  /** Path part for operation `removeContactsFromSegment()` */
  static readonly RemoveContactsFromSegmentPath = '/v1/api/ui/contactSegment/{ref}/contacts/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeContactsFromSegment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeContactsFromSegment$Response(params: RemoveContactsFromSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSegmentMembersResult>> {
    return removeContactsFromSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeContactsFromSegment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeContactsFromSegment(params: RemoveContactsFromSegment$Params, context?: HttpContext): Observable<ApiResponseContactSegmentMembersResult> {
    return this.removeContactsFromSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactSegmentMembersResult>): ApiResponseContactSegmentMembersResult => r.body)
    );
  }

  /** Path part for operation `searchContactSegment()` */
  static readonly SearchContactSegmentPath = '/v1/api/ui/contactSegment/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchContactSegment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchContactSegment$Response(params: SearchContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultContactSegment>> {
    return searchContactSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchContactSegment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchContactSegment(params: SearchContactSegment$Params, context?: HttpContext): Observable<ApiResponsePagedResultContactSegment> {
    return this.searchContactSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultContactSegment>): ApiResponsePagedResultContactSegment => r.body)
    );
  }

  /** Path part for operation `listContactSegment()` */
  static readonly ListContactSegmentPath = '/v1/api/ui/contactSegment/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listContactSegment()` instead.
   *
   * This method doesn't expect any request body.
   */
  listContactSegment$Response(params: ListContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListContactSegment>> {
    return listContactSegment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listContactSegment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listContactSegment(params: ListContactSegment$Params, context?: HttpContext): Observable<ApiResponseListContactSegment> {
    return this.listContactSegment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListContactSegment>): ApiResponseListContactSegment => r.body)
    );
  }

}
